// Trip feature types for Globe Pinned

export type TripCategory = 'leisure' | 'business' | 'adventure' | 'cultural' | 'gastronomic' | 'other';

export type PrivacyLevel = 'public' | 'friends' | 'private';

export interface Trip {
  id: string;
  userId: string;
  title: string;
  description: string | null;
  startDate: string;
  endDate: string;
  category: TripCategory;
  privacy: PrivacyLevel;
  createdAt: string;
  updatedAt: string;
  pinCount?: number;
  countryCode?: string | null;
}

export interface CreateTripData {
  title: string;
  description?: string;
  startDate: string;
  endDate: string;
  category: TripCategory;
  privacy: PrivacyLevel;
}

export interface UpdateTripData {
  title?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  category?: TripCategory;
  privacy?: PrivacyLevel;
}

export interface TripsResponse {
  trips: Trip[];
  total: number;
}

export interface TripPin {
  id: string;
  latitude: number;
  longitude: number;
  title: string | null;
  visitDate: string | null;
}

export interface TripPhoto {
  id: string;
  thumbnailUrl: string;
  title: string | null;
  createdAt: string;
}

export interface TripDetail extends Trip {
  pins: TripPin[];
  photos: TripPhoto[];
}

export const TRIP_CATEGORIES: { value: TripCategory; label: string }[] = [
  { value: 'leisure', label: 'Lazer' },
  { value: 'business', label: 'Negocios' },
  { value: 'adventure', label: 'Aventura' },
  { value: 'cultural', label: 'Cultural' },
  { value: 'gastronomic', label: 'Gastronomico' },
  { value: 'other', label: 'Outro' },
];

export const PRIVACY_LEVELS: { value: PrivacyLevel; label: string }[] = [
  { value: 'public', label: 'Publico' },
  { value: 'friends', label: 'Amigos' },
  { value: 'private', label: 'Privado' },
];
